// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCAtWlvozrIsMetDRMHBLHQ-YJb80UnRlI",
  authDomain: "slr-golfapp.firebaseapp.com",
  projectId: "slr-golfapp",
  storageBucket: "slr-golfapp.firebasestorage.app",
  messagingSenderId: "1077076065480",
  appId: "1:1077076065480:web:863ee853487685684af9fd",
  measurementId: "G-32PJ9CEW35"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth }; // ✅ Named exports